import React, { FC } from 'react'
import SVGUniqueID from 'react-svg-unique-id'

import { colors as Colors } from '../../themes/Colors'

import { SVGComponentProps } from '../type'

interface IconProps extends SVGComponentProps {
  status: boolean
  isNotValid: boolean
}

const OutlineEmailIcon: FC<IconProps> = ({
  width = 20,
  height = 20,
  status = false,
  isNotValid = false,
  ...other
}) => {
  const fill = isNotValid
    ? Colors.lightRed400
    : status
    ? Colors.cerulean
    : Colors.slateGray

  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 20 20"
        {...other}
      >
        <path
          fill={fill}
          d="M14.167 17.708H5.833c-3.041 0-4.791-1.75-4.791-4.791V7.083c0-3.041 1.75-4.791 4.791-4.791h8.334c3.041 0 4.791 1.75 4.791 4.791v5.834c0 3.041-1.75 4.791-4.791 4.791zM5.833 3.542c-2.383 0-3.541 1.158-3.541 3.541v5.834c0 2.383 1.158 3.541 3.541 3.541h8.334c2.383 0 3.541-1.158 3.541-3.541V7.083c0-2.383-1.158-3.541-3.541-3.541H5.833z"
        ></path>
        <path
          fill={fill}
          d="M10 10.725c-.7 0-1.409-.217-1.95-.658L5.44 7.983a.623.623 0 01.776-.975l2.608 2.084c.633.508 1.708.508 2.341 0l2.609-2.084a.615.615 0 01.875.1.615.615 0 01-.1.875l-2.609 2.084c-.533.441-1.241.658-1.941.658z"
        ></path>
      </svg>
    </SVGUniqueID>
  )
}

export { OutlineEmailIcon }
